import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { ErrorMessage, Note, NoteWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateNote(): UseMutationResult<
  AxiosResponse<Note>,
  AxiosError<ErrorMessage>,
  NoteWrite
> {
  const queryClient = useQueryClient();

  const updateNote = useCallback((note: NoteWrite): Promise<AxiosResponse<Note>> => {
    return client.put(`notes/${note.noteId}/`, note);
  }, []);

  return useMutation(updateNote, {
    onSuccess: () => {
      queryClient.invalidateQueries('notes');
    },
  });
}
